import { motion, useInView } from 'framer-motion';
import { useRef } from 'react';

import { DEEP_PURPLE, EASE_OUT, NOPING_GREEN, PURPLE, SILVER } from '../constants';

interface ArsenalCardProps {
  name: string;
  tagline: string;
  desc: string;
  iconPath: string;
  secondaryPath?: string;
  delay?: number;
}

export function ArsenalCard({ name, tagline, desc, iconPath, secondaryPath, delay = 0 }: ArsenalCardProps) {
  const ref = useRef<HTMLDivElement>(null);
  const inView = useInView(ref, { once: true, margin: '-60px' });

  return (
    <motion.div ref={ref} initial={{ opacity: 0, y: 24 }} animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 24 }} transition={{ duration: 0.5, delay, ease: EASE_OUT }} className='group relative rounded-xl p-6 transition-all duration-300 hover:-translate-y-1' style={{ background: `linear-gradient(135deg, ${PURPLE}80, ${DEEP_PURPLE}CC)`, border: `1px solid ${NOPING_GREEN}10` }}>
      {/* Icon */}
      <div className='mb-4'>
        <svg viewBox='0 0 24 24' fill='none' className='size-7' stroke={NOPING_GREEN} strokeWidth={2} strokeLinecap='round' strokeLinejoin='round'>
          <path d={iconPath} />
          {secondaryPath && <path d={secondaryPath} />}
        </svg>
      </div>

      {/* Title */}
      <h3 className='mb-1 text-lg font-bold' style={{ fontFamily: 'var(--font-bai)' }}>
        {name}
      </h3>
      <p className='mb-3 text-sm font-semibold italic' style={{ color: NOPING_GREEN, fontFamily: 'var(--font-outfit)' }}>
        {tagline}
      </p>
      <p className='text-sm leading-relaxed' style={{ color: SILVER, fontFamily: 'var(--font-outfit)' }}>
        {desc}
      </p>

      {/* Bottom accent bar on hover */}
      <div className='absolute inset-x-6 bottom-0 h-[2px] rounded-full opacity-0 transition-opacity duration-300 group-hover:opacity-100' style={{ background: `linear-gradient(90deg, transparent, ${NOPING_GREEN}, transparent)` }} />
    </motion.div>
  );
}
